/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { DateTimePeriod } from './date-time-period';


export interface SearchMaintenanceRequestsRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
    statusIds?: Array<number> | null;
    maintenanceTypeIds?: Array<number> | null;
    facilityIds?: Array<string> | null;
    serviceCenterIds?: Array<string> | null;
    warrantyTypeIds?: Array<number> | null;
    datePeriod?: DateTimePeriod;
}

